export const ANDROID_URL = 'https://play.google.com/apps/internaltest/4701482663822499913';
export const IOS_URL = 'https://testflight.apple.com/join/FZ5RPxcf';
// Прямая загрузка APK с текущего сервера (файл кладётся в wwwroot/downloads/SportProgress.apk)
export const APK_URL = '/download/android';
export const DISMISS_KEY = 'appBannerDismissed';

/**
 * isIOS    - iPhone/iPad/iPod, включая iPadOS в режиме «как на компьютере» (в User-Agent он выглядит как Macintosh, но есть сенсор).
 * isApple  - iOS или macOS (любой браузер на технике Apple). Им APK и Google Play не показываем.
 * isMobile - телефон или планшет на Android/iOS.
 */
export function detectMobilePlatform() {
    if (typeof navigator === 'undefined') {
        return { isAndroid: false, isIOS: false, isApple: false, isMobile: false };
    }
    const ua = navigator.userAgent;
    const isAndroid = /Android/i.test(ua);
    const isMac = /Macintosh|Mac OS X/i.test(ua) && !isAndroid;
    const isIpadOsDesktopMode = isMac && (navigator.maxTouchPoints || 0) > 1;
    const isIOS = /iPhone|iPad|iPod/i.test(ua) || isIpadOsDesktopMode;
    const isApple = isIOS || isMac || /iPhone|iPad|iPod/i.test(ua);
    return { isAndroid, isIOS, isApple, isMobile: isAndroid || isIOS };
}

/**
 * Какие кнопки скачивания показывать.
 * Apple (iOS/macOS): только TestFlight. Android: Google Play и APK с сайта.
 * Остальные (Windows, Linux): все три, чтобы можно было отправить ссылку на телефон.
 */
export function getDownloadOptions() {
    const { isAndroid, isApple } = detectMobilePlatform();
    if (isApple) return { googlePlay: false, apk: false, testFlight: true };
    if (isAndroid) return { googlePlay: true, apk: true, testFlight: false };
    return { googlePlay: true, apk: true, testFlight: true };
}

export function shouldShowMobileAppModal() {
    const { isMobile } = detectMobilePlatform();
    if (!isMobile) return false;
    if (sessionStorage.getItem(DISMISS_KEY) === 'true') return false;
    const isNotAuthed = !localStorage.getItem('token');
    const isFirstLogin = localStorage.getItem('firstLogin') === 'true';
    return isNotAuthed || isFirstLogin;
}

export function markFirstLoginIfNeeded() {
    if (!localStorage.getItem('hasLoggedInBefore')) {
        localStorage.setItem('firstLogin', 'true');
        localStorage.setItem('hasLoggedInBefore', 'true');
    }
}
